import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router"

@Component({
  selector: 'app-nav-illustration',
  templateUrl: './nav-illustration.component.html',
  styleUrls: ['./nav-illustration.component.css']
})
export class NavIllustrationComponent implements OnInit {
  private navIllustration = []

  constructor(private router:Router) { }

  ngOnInit() {
    this.navIllustration = [
      {field:'HealthCare', image: '../../../assets/icons/healthcare_illustration.svg', backGrounColor:'#99C2E2'},
      {field:'LongTermCare', image: '../../../assets/icons/long_term_care_illustration.svg', backGrounColor:'#C8B9F0'},
      {field:'CombinedCare', image: '../../../assets/icons/combination_illustration.svg', backGrounColor:'#92DEDC'},
      {field:'MMT', image: '../../../assets/icons/long_term_care_illustration.svg', backGrounColor:'#8BA6C6'},
      {field:'SocialSecurity', image: '../../../assets/icons/combination_illustration.svg', backGrounColor:'#00E5F0'},
    ]
  }

  redirect(scenario) {
    if (scenario == 'HealthCare') {
      //this.router.navigate(['/reports/healthcare/options']);
      this.router.navigate(['/clients/edit/healthcare/options']);
    }
    if (scenario == 'LongTermCare') {
      //this.router.navigate(['/reports/long-term-care/options']);
      this.router.navigate(['/clients/edit/long-term-care/options']);
    }
    if (scenario == 'CombinedCare') {
      //this.router.navigate(['/reports/create/hcltc']);
      this.router.navigate(['/clients/edit/combined/options']);
    }
    if (scenario == 'MMT') {
      //this.router.navigate(['/reports/medicare-means-testing/options']);
      this.router.navigate(['/clients/edit/medicare-means-testing/options']);
    }
    if (scenario == 'SocialSecurity') {
      //this.router.navigate(['/reports/social-security/options']);
      this.router.navigate(['/clients/edit/social-security/options']);
    }

  }

}
